"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDynamicContentForHome = void 0;
const react_query_1 = require("@tanstack/react-query");
const react_1 = require("react");
const providers_1 = require("../../providers");
const dynamic_content_1 = require("../../repositories/dynamic-content");
const utils_1 = require("../../utils");
const useCartCycle_1 = require("../useCartCycle");
const useReseller_1 = require("../useReseller");
const utils_2 = require("./utils");
const HOME_DOCUMENT_TYPE = 'home_minha_loja_digital';
class UseDynamicContentForHomeError extends Error {
    constructor(message) {
        super(message);
        this.name = 'UseDynamicContentForHomeError';
    }
}
const useDynamicContentForHome = ({ resellerSlug }) => {
    var _a;
    const businessUnit = providers_1.BrandProvider.getBrand();
    const { reseller } = (0, useReseller_1.useReseller)({ resellerSlug, businessUnit });
    const uf = (0, utils_1.getUf)(reseller);
    const { cycle } = (0, useCartCycle_1.useCartCycle)({
        businessUnit,
        resellerSlug,
        state: uf,
    });
    const dynamicContentRepository = (0, react_1.useMemo)(() => new dynamic_content_1.DynamicContentRepository(utils_1.envConfig.apiURL), []);
    const cycleYear = (_a = cycle === null || cycle === void 0 ? void 0 : cycle.cycle) === null || _a === void 0 ? void 0 : _a.substring(0, 4);
    const enabled = (0, react_1.useMemo)(() => cycle !== undefined, [cycle]);
    const params = {
        document: HOME_DOCUMENT_TYPE,
        cycle: cycle === null || cycle === void 0 ? void 0 : cycle.number,
        year: cycleYear,
        brand: providers_1.BrandProvider.getBrandForDynamicContent(),
    };
    const selectFirstItemByBrand = (data) => {
        var _a, _b;
        try {
            const filteredItemsByBrand = ((_b = (_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.items) !== null && _b !== void 0 ? _b : []).filter((item) => { var _a; return String((_a = item.data) === null || _a === void 0 ? void 0 : _a.brand).toUpperCase() === params.brand.toUpperCase(); });
            return filteredItemsByBrand.length ? filteredItemsByBrand[0] : null;
        }
        catch (error) {
            return null;
        }
    };
    const queryResults = (0, react_query_1.useQuery)({
        queryKey: ['dynamicContent', params],
        context: providers_1.BarrilQueryClientContext,
        queryFn: ({ signal }) => __awaiter(void 0, void 0, void 0, function* () {
            try {
                return yield dynamicContentRepository.get(params, { signal });
            }
            catch (error) {
                window.NREUM.noticeError(new UseDynamicContentForHomeError('Failed to fetch dynamic content'), {
                    customAttributes: Object.assign(Object.assign({}, params), { error: error instanceof Error ? error.message : String(error) }),
                    customError: true,
                });
                throw error;
            }
        }),
        select: selectFirstItemByBrand,
        enabled,
    });
    const memoizedData = (0, react_1.useMemo)(() => {
        try {
            if (!queryResults.data) {
                return null;
            }
            const validated = utils_2.dynamicContentItemDataSchema.validateSync(queryResults.data, {
                stripUnknown: false,
            });
            return validated;
        }
        catch (error) {
            window.NREUM.noticeError(new UseDynamicContentForHomeError('Failed to parse dynamic content'), {
                customAttributes: Object.assign(Object.assign({}, params), { error: error instanceof Error ? error.message : String(error) }),
                customError: true,
            });
            return null;
        }
    }, [queryResults.data]);
    return Object.assign(Object.assign({}, queryResults), { data: memoizedData });
};
exports.useDynamicContentForHome = useDynamicContentForHome;
